import loadable from '@loadable/component';

export const AsyncTripboard = loadable(() =>
    import(
        /* webpackChunkName: "tripboard" */
        /* webpackPrefetch: true */
        './TripBoardComponent'
    )
);

AsyncTripboard.displayName = 'AsyncTripboard';
